"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardFinder = void 0;
const ColoniesCardManifest_1 = require("./cards/colonies/ColoniesCardManifest");
const PreludeCardManifest_1 = require("./cards/prelude/PreludeCardManifest");
const PromoCardManifest_1 = require("./cards/promo/PromoCardManifest");
const StandardCardManifests_1 = require("./cards/StandardCardManifests");
const TurmoilCardManifest_1 = require("./cards/turmoil/TurmoilCardManifest");
const VenusCardManifest_1 = require("./cards/venusNext/VenusCardManifest");
const CommunityCardManifest_1 = require("./cards/community/CommunityCardManifest");
const AresCardManifest_1 = require("./cards/ares/AresCardManifest");
const MoonCardManifest_1 = require("./cards/moon/MoonCardManifest");
const LeaderCardManifest_1 = require("./cards/leaders/LeaderCardManifest");
const AutomaCardManifest_1 = require("./cards/automa/AutomaCardManifest");
const PreludeTwoCardManifest_1 = require("./cards/preludeTwo/PreludeTwoCardManifest");
class CardFinder {
    static getDecks() {
        if (CardFinder.decks === undefined) {
            CardFinder.decks = [
                StandardCardManifests_1.BASE_CARD_MANIFEST,
                StandardCardManifests_1.CORP_ERA_CARD_MANIFEST,
                PromoCardManifest_1.PROMO_CARD_MANIFEST,
                VenusCardManifest_1.VENUS_CARD_MANIFEST,
                ColoniesCardManifest_1.COLONIES_CARD_MANIFEST,
                PreludeCardManifest_1.PRELUDE_CARD_MANIFEST,
                PreludeTwoCardManifest_1.PRELUDE_TWO_CARD_MANIFEST,
                TurmoilCardManifest_1.TURMOIL_CARD_MANIFEST,
                AresCardManifest_1.ARES_CARD_MANIFEST,
                CommunityCardManifest_1.COMMUNITY_CARD_MANIFEST,
                MoonCardManifest_1.MOON_CARD_MANIFEST,
                LeaderCardManifest_1.LEADER_CARD_MANIFEST,
                AutomaCardManifest_1.AUTOMA_CARD_MANIFEST,
            ];
        }
        return CardFinder.decks;
    }
    getCardByName(cardName, decks) {
        let found;
        CardFinder.getDecks().some((manifest) => {
            decks(manifest).some((deck) => {
                found = deck.findByCardName(cardName);
                return found;
            });
            return found;
        });
        if (found !== undefined) {
            return new found.Factory();
        }
        console.warn(`card not found ${cardName}`);
        return undefined;
    }
    getCorporationCardByName(cardName) {
        return this.getCardByName(cardName, (manifest) => [manifest.corporationCards]);
    }
    getProjectCardByName(cardName) {
        return this.getCardByName(cardName, (manifest) => [manifest.projectCards, manifest.preludeCards, manifest.leaderCards]);
    }
    cardsFromJSON(cards) {
        if (cards === undefined) {
            console.warn('missing cards calling cardsFromJSON');
            return [];
        }
        const result = [];
        cards.forEach((element) => {
            if (typeof element !== 'string') {
                element = element.name;
            }
            const card = this.getProjectCardByName(element);
            if (card !== undefined) {
                result.push(card);
            }
            else {
                console.warn(`card ${element} not found while loading game.`);
            }
        });
        return result;
    }
    corporationCardsFromJSON(cards) {
        if (cards === undefined) {
            console.warn('missing cards calling corporationCardsFromJSON');
            return [];
        }
        const result = [];
        cards.forEach((element) => {
            if (typeof element !== 'string') {
                element = element.name;
            }
            const card = this.getCorporationCardByName(element);
            if (card !== undefined) {
                result.push(card);
            }
            else {
                console.warn(`corporation ${element} not found while loading game.`);
            }
        });
        return result;
    }
}
exports.CardFinder = CardFinder;
//# sourceMappingURL=CardFinder.js.map